import { get, post } from "../ApiHelper/index"
import { TAKE_PARAMETER_LISTKEY_DROPDOWN } from "../apis/_index";

export const phongbanDropdown = (key:any) => {
    return new Promise(async resolve => {
        // dispatch({
        //     type: 'LISTNANGLUCNHANSU', data: initialState
        // });
        return await get(TAKE_PARAMETER_LISTKEY_DROPDOWN + key)
            .then((res: any) => {

                resolve({
                    status: true,
                    data: res.data.Data
                });
            })
            .catch((err: any) => {
                resolve({
                    status: false,
                    err: err
                });
            })
    })
}

